import {
  closestCorners,
  type CollisionDetection,
  pointerWithin,
} from '@dnd-kit/core';

export const customCollisionDetection: CollisionDetection = args => {
  // We need higher precision for panels since we need to handle dragging a panel into a closed section.
  if (args.active.data.current?.type === 'panel') {
    // https://docs.dndkit.com/api-documentation/context-provider/collision-detection-algorithms#pointer-within
    return pointerWithin(args);
  }

  return closestCorners(args);
};
